var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#BF1231",
    fillOpacity: 0.19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9833 12.2167L17.6667 15.3501C15.75 16.0667 14.1833 18.3334 14.1833 20.3667V32.7501C14.1833 34.7167 15.4833 37.3001 17.0667 38.4834L24.2333 43.8334C26.5833 45.6001 30.45 45.6001 32.8 43.8334L39.9667 38.4834C41.55 37.3001 42.85 34.7167 42.85 32.7501V20.3667C42.85 18.3167 41.2833 16.0501 39.3667 15.3334L31.05 12.2167C29.6333 11.7001 27.3667 11.7001 25.9833 12.2167Z",
    stroke: "#BF1231",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5834 28.2834L26.2667 30.9667L33.4334 23.8",
    stroke: "#BF1231",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.cfffe503c6fdc211b6a54f4ad68dbbb4.svg";
export { ForwardRef as ReactComponent };